import { render } from "./IntegrationGallery.vue?vue&type=template&id=da638622&scoped=true&ts=true"
import script from "./IntegrationGallery.vue?vue&type=script&lang=ts"
export * from "./IntegrationGallery.vue?vue&type=script&lang=ts"

import "./IntegrationGallery.vue?vue&type=style&index=0&id=da638622&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da638622"]])

export default __exports__